import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Route, UrlSegment, Router } from "@angular/router";
import { LG_LOCALIZATION_SETTINGS } from "@logex/framework/lg-localization";
import { SharedLocalizationSettingsService } from "@mrdm-self-service-frontend/shared/util-logex-framework-setup";
import { Observable } from "rxjs";
import { tap, take } from "rxjs/operators";
import { Auth0AuthorizationService } from "./auth0-authorization.service";

@Injectable({
    providedIn: "root"
})
export class Auth0Guard  {
    private _router = inject(Router);
    private _auth = inject(Auth0AuthorizationService);
    private _localizationSettings = inject<SharedLocalizationSettingsService>(LG_LOCALIZATION_SETTINGS);


    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean | UrlTree> | boolean {
        return this._auth.isAuthenticated$.pipe(
            take(1),
            tap(loggedIn => {
                if (!loggedIn) {
                    this._auth.login(
                        state.url,
                        this._localizationSettings.loginLanguage,
                        next.queryParams
                    );
                }
            })
        );
    }

    canActivateChild(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean | UrlTree> | boolean {
        return this.canActivate(next, state);
    }

    canLoad(
        route: Route,
        segments: UrlSegment[]
    ): Observable<boolean> | Promise<boolean> | boolean {
        return this._auth.isAuthenticated$.pipe(
            take(1),
            tap(loggedIn => {
                if (!loggedIn) {
                    const queryParams =
                        this._router.currentNavigation()?.extractedUrl.queryParams;

                    const fullPath = segments.reduce((path, currentSegment) => {
                        return `${path}/${currentSegment.path}`;
                    }, "");

                    this._auth.login(
                        fullPath,
                        this._localizationSettings.loginLanguage,
                        queryParams
                    );
                }
            })
        );
    }
}
